module.exports = __webpack_public_path__ + "static/media/duo-lockup-bar.8462f725.svg";